<template>
    <div>
        <footer id="footer-web">
        </footer>
        <div class="modal-cookies" v-if="allowCookies">
            <p>Este sitio web utiliza cookies. Para obtener más información, puedes consultar nuestra Política de Cookies. Al continuar navegando aceptas la <a @click="$router.push('/cookies') & footerGA4Click('click', 'politica de cookies', 'footer')" class="links">POLÍTICA DE COOKIES</a>, la <a @click="$router.push('/politics') & footerGA4Click('click', 'aviso de privacidad', 'footer')" class="links">POLÍTICA DE PRIVACIDAD</a>, y los <a @click="$router.push('/tycos') & footerGA4Click('click', 'terminos y condiciones', 'footer')" class="links">TÉRMINOS Y CONDICIONES</a> de este sitio web.</p>
            <a class="btn-cookies" @click="allowCook">
                CERRAR
            </a>
        </div>
        <Modal v-if="showModal" v-bind:wichModal="wichModal" @close="showModal = false"/>
        <ModalCookies v-if="showModalC" v-bind:wichModalC="wichModalC" @close="showModalC = false"/>
    </div>
</template>

<script>
import Modal from "@/components/Modal";
import ModalCookies from "@/components/ModalCookies";
import tagFunctions from '@/utils/tagFunctions.js'

export default {
    name: "BannerCookies",
    data: () =>({
        allowCookies: true,
        showModal: false,
        wichModal: "tycos",
        showModalC: false,
        wichModalC: "tycos",
    }),
    components: {
        Modal,
        ModalCookies,
    },
    computed: {
    },
    created: function () {
        if (localStorage.getItem('allowCookies')) {
            const isAllowCookies = localStorage.getItem('allowCookies')
            if (isAllowCookies === 'yes') {
                this.allowCookies = false
            }
        }
    },
    methods: {
        allowCook: function() {
            this.allowCookies = false;
            localStorage.setItem('allowCookies','yes')
        },
        popUpModal(modalType) {
            this.showModal = true;
            this.wichModal = modalType;
        },
        popUpModalC(modalTypeC) {
            this.showModalC = true;
            this.wichModalC = modalTypeC;
        },
        footerGA4Click(action, element, section) {
            tagFunctions.user_interactionPush(action, element, section)
        },
    }
};
</script>

<style lang="scss">
footer#footer-web {
    display: flex;
    align-items: end;
}
.modal-cookies {
    position: fixed;
    bottom: 0;
    z-index: 3;
    background: rgba(5, 5, 5, 0.8);
    color: white;
    width: 100%;
    height: 6.5vw;
    padding: .2vw .5vw .7vw .5vw;
    display: flex;
    align-items: flex-start;
}
.modal-cookies p {
    padding: .1vw .5vw .2vw 3.5vw;
    width: 80%;
    font-size: 1.6vw !important;
    font-family: "Wood-Bonnet-Grotesque";
}
a {
    cursor: pointer;
}
.modal-cookies .links {
    color: rgb(0, 190, 255);
    text-decoration: underline;
}

.modal-cookies .btn-cookies {
    border-color: white;
    border: solid .2vw;
    margin: 1.3vw 0 0 2.5vw;
    padding: .7vw 1vw;
    font-size: 1.6vw !important;
    background: transparent;
    font-family: "Wood-Bonnet-Grotesque";
}

@media screen and (max-width: 768px) {
    .modal-cookies {
        position: fixed;
        bottom: 0;
        z-index: 3;
        width: 100%;
        height: 30vw;
    }
    .modal-cookies p {
        padding: .5vw .5vw .5vw 3.5vw;
        width: 74%;
        font-size: 4vw !important;
    }
    .modal-cookies .btn-cookies {
        margin: 9.3vw 0 0 3vw;
        font-size: 4vw !important;
        padding: 1vw 2vw;
        border: solid .4vw;
    }
}
</style>